export function useShared () {
  const CDN_URL = 'https://raumpionierestorage.blob.core.windows.net/images'
  return {
    CDN_URL,
    interpretErrorMessage (e) {
      const error = JSON.parse(JSON.stringify(e))
      if (error && error.graphQLErrors && error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].extensions && error.graphQLErrors[0].extensions.response && error.graphQLErrors[0].extensions.response.message && error.graphQLErrors[0].extensions.response.message[0]) {
        return error.graphQLErrors[0].extensions.response.message[0]
      } else {
        return 'Leider haben wir ein Serverproblem auf unserer Seite festgestellt. Bitte kontaktiere uns auf hallo@raumpioniere.io, damit wir dieses rasch beheben können.'
      }
    }
  }
}
